import { createElementIdSlice } from '../utils/action/createElementSlice';
export const ComboBoxState = createElementIdSlice({
    elementName: 'combo-box',
    initialState: {},
    reducers: {},
});
